import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';

import pageTitle from '../utils/pageTitles.json';
import UserPlanTable from 'src/sections/userPlans/UserPlanTable';

const MainSection = styled('div')(() => ({
  width: '100%',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'rgb(240, 240, 240)',
  padding: '64px 20px 0px 88px',
}));

const HeadingSection = styled(Box)(() => ({
  padding: '20px 0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const ContentWrapper = styled(Box)(() => ({
  flex: 1,
  backgroundColor: '#fff',
  borderRadius: '6px',
  marginBottom: '80px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}));

const TabContent = styled(Box)(() => ({
  flex: 1,
  overflowY: 'auto',
  overflow: 'hidden',
  flex: 1,
}));

const UserPlanList = () => {
  const [tabIndex, setTabIndex] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <>
      <Helmet>
        <title>{`${pageTitle?.userPlanList}`}</title>
      </Helmet>

      <MainSection>
        <HeadingSection>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <SubscriptionsIcon />
            <Typography variant="h5" sx={{ color: 'grey.10', fontWeight: 600 }}>
              User Plan Table
            </Typography>
          </Box>
        </HeadingSection>

        <Box
          sx={{
            px: 2,
            backgroundColor: 'white',
            borderBottom: '1px solid #e0e0e0',
          }}
        >
          <Tabs value={tabIndex} onChange={handleTabChange}>
            <Tab label="Completed" />
            <Tab label="Pending" />
          </Tabs>
        </Box>
        <TabContent
          sx={{
            mb: '8px',
          }}
        >
          {tabIndex === 0 && <UserPlanTable status="completed" />}
          {tabIndex === 1 && <UserPlanTable status="pending" />}
        </TabContent>
      </MainSection>
    </>
  );
};

export default UserPlanList;
